<div *ngIf="loading" class="absolute inset-0 flex justify-center items-center z-10 bg-slate-900">
  <fa-icon icon="circle-notch" [spin]="true" size="3x"></fa-icon>
</div>

<div class="absolute inset-0">

  

  <div class="h-full flex flex-col justify-between items-center text-center" >

    <div #top class="w-full">
      <app-alert *ngIf="error" type="ERROR">
        Error encountered
        {{error | json}}
      </app-alert>
  
      <div *ngIf="!connected && firstConnectionCompleted" class="p-3 w-full flex flex-row text-sm gap-3 border-b flex flex-row justify-between items-center bg-red-950 text-red-400 border-red-400">
        <span>
          <fa-icon icon="warning"  class="mr-1"></fa-icon>
          Connection Lost
        </span>
        <span>
          Reconnecting
          <fa-icon icon="spinner" animation="spin" class="ml-1"></fa-icon>
        </span>
      </div>

      <div class="bg-slate-800 w-full grid grid-cols-3 items-start pt-5 text-center">

        <div >
          <p class="text-muted text-xs">
            participation
          </p>
          <div>
            <app-hud [pointsOffered]="attendee?.points?.participationPointsOffered" [pointsEarned]="attendee?.points?.participationPointsEarned"></app-hud>
          </div>
        </div>
  
  
        <div>
          <div class="text-muted text-xs">score</div>
          <div >
            <app-score [score]="attendee?.points?.pointsEarned"></app-score>
          </div>
        </div>
  
        <div>
          <p class="text-muted text-xs">
            understanding
          </p>
          <div>
            <app-hud [pointsOffered]="attendee?.points?.knowledgePointsOffered" [pointsEarned]="attendee?.points?.knowledgePointsEarned"></app-hud>
  
          </div>
        </div>
      </div>

    </div>
    

    <div #center >

      <div *ngIf="hasActiveVolunteerTask">
        <div *ngIf="volunteerTask!.recruiting">

          <div *ngIf="volunteerTask!.bonus" class="mb-12">
            <p class="text-yellow-200 mb-3">
              <fa-icon icon="star" class="mr-1"></fa-icon>
              Bonus Task
            </p>

            <p class="text-muted text-sm">
              Opt in to recover participation health<br/>and a chance to recover understanding health<br/>(or gain armour if you are already full)
            </p>

          </div>

          <div *ngIf="!volunteerTask!.forGroups || (group && group.status == 'ACTIVE')">
            <div class="my-5">Are you <span *ngIf="volunteerTask!.forGroups">and your groupmates</span> game?</div>

            <div class="flex flex-row justify-center gap-5 mb-5">

              <button mat-fab [class]="optInClass" (click)="setVolunteerTaskDecision('OPT_IN')" >
                <fa-icon icon="thumbs-up" size="2x"></fa-icon>
              </button>

              <button mat-fab [class]="optOutClass" (click)="setVolunteerTaskDecision('OPT_OUT')" >
                <fa-icon icon="thumbs-down" size="2x"></fa-icon>
              </button>

            </div>
          </div>
  
          <div *ngIf="volunteerTask!.forGroups && (!group || group.status != 'ACTIVE')">
            <p class="my-5">
              You aren't currently in a group
              <br/>
              so you have to sit this one out
            </p>
          </div>

        </div>

        <div *ngIf="!volunteerTask!.recruiting">

          <div *ngIf="isChosen || isGroupChosen">

            <h2 class="mb-5">
              You're up!
            </h2>

          </div>
          <p *ngIf="!isChosen && !isGroupChosen">
            Someone else is in the spotlight
          </p>

        </div>

      </div>


      <div *ngIf="hasActiveClassTask">

        <app-classtask [task]="classTask" [response]="classTaskResponse"></app-classtask>

      </div>


      <div *ngIf="quiz && hasActiveQuiz && currentQuestion">

        <div *ngIf="!quiz.showingAnswer">

          <div *ngIf="currentQuestion.bonus" class="mb-12">
            <p class="text-yellow-200 mb-3">
              <fa-icon icon="star" class="mr-1"></fa-icon>
              Bonus Question
            </p>

            <p class="text-muted text-sm">
              Answer correctly to recover participation & understanding health<br/>(or gain armour if you are already full)
            </p>

          </div>


          <p class="mb-6">
            Make your choice
          </p>
          <div class="flex flex-row flex-wrap gap-6 justify-center">
            <div *ngFor="let choice of currentQuestion.choices ; let choiceIndex = index">
              <div class="w-16 h-16 rounded-full flex flex-col justify-center items-center cursor-pointer" [style]="getChoiceStyle(choiceIndex)" (click)="choose(choiceIndex)">
                <h2>{{quizzes.getLetter(choiceIndex)}}</h2>
              </div>
            </div>
          </div>

        </div>

        <div *ngIf="quiz.showingAnswer">

          <div class="text-positive" *ngIf="currentQuestionChoice == correctChoiceIndex">
            <fa-icon icon="circle-check" size="3x"></fa-icon>
            <h4>Correct!</h4>
          </div>

          <div class="text-negative" *ngIf="currentQuestionChoice != undefined && currentQuestionChoice != correctChoiceIndex">
            <fa-icon icon="times-circle" size="3x"></fa-icon>
            <br/>
            <h4>Incorrect</h4>
          </div>

          <div class="text-muted" *ngIf="currentQuestionChoice === undefined">
            <fa-icon icon="circle-minus" size="3x"></fa-icon>
            <br/>
            <h4>Passed</h4>
          </div>

        </div>

      </div>

      <div *ngIf="!hasActiveVolunteerTask && !hasActiveClassTask && !hasActiveQuiz">

        <h2>Stand by</h2>

      </div>

    </div>


    <div #bottom class="bg-slate-800 w-full">

      <div *ngIf="hasActiveVolunteerTask">
        
      </div>

      <div >

        <div *ngIf="group && group.status == 'ACTIVE'" class="flex flex-col justify-center gap-3">

          <div class="mt-5 text-muted text-sm">
            Group {{group.index}}
          </div>

          <div class="flex flex-row justify-center flex-wrap gap-6 mb-5">
            <div *ngFor="let member of group.members">
              <app-avatar [user]="member" size="sm" (click)="showUser(member)" class="cursor-pointer">
              </app-avatar>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
